import type { Page } from '../../types';
import { disposalBarrierOptions } from './data';

const barriersAndComments: Page[] = [
  {
    pageType: 'question',
    title: 'Barriers and comments',
    name: 'barriers-and-comments',
    description:
      "The workbook says the primary barrier should be completed for material sites, defined as forecast receipt value at or above GBP1m and/or over 1 hectare. Comments are optional and can be used to explain status, dependencies or major changes.",
    questions: [
      {
        questionType: 'select',
        title: 'Primary Barrier to disposal',
        name: 'primary-barrier-to-disposal',
        hintOption: 'Select a primary barrier',
        options: disposalBarrierOptions,
        detailsHeading: 'Barrier definitions',
        detailsContent: `<p><strong>Operational strategy/ requirements:</strong> Operational requirements may be unclear, subject to change or need to be clarified (e.g. awaiting outcome of a strategic service review)</p>

<p><strong>Planning:</strong> Planning: Pre-application advice stage e.g. agreeing development options/ suitable/ alternative end use (outdated Local Plan; infrastructure demands etc.) AND/ OR Formal submission stage e.g. difficulty/ delay in obtaining outline planning approval (capacity or capability of LA planning team; environmental or ecological issues; heritage requirements etc.)</p>

<p><strong>Funding/ affordability:</strong> Funds for disposal project are unavailable/ insufficient (to e.g. hire project team; undertake enabling or de-risking activity; reprovide facility etc.)</p>

<p><strong>Policy/ legislative:</strong> A policy or legislative change would be required</p>

<p><strong>Internal capacity or capability:</strong> Lack of capacity or access to required professional expertise</p>

<p><strong>Other:</strong> Please describe the barrier in the free text comments field</p>`,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Free text comments',
        name: 'free-text-comments',
        hint: 'Use this field for explanatory commentary, including current status, the main barrier or dependencies.',
        textRows: 6,
      },
    ],
  },
];

export default barriersAndComments;
